import PaginationContainer from './PaginationContainer'
import Pagination from './Pagination'
export { Pagination }
export { PaginationContainer }
export default PaginationContainer



// WEBPACK FOOTER //
// ./src/components/Pagination/index.js